// orderBy=column1 direction1
// orderBy=column1 direction1,column2 direction2
export const sortModelToStandardQueryParam = (sorters: string[]): string => {
  const sortingParameter = sorters ? sorters.join(',') : null;

  if (sortingParameter) {
    return `$orderBy=${encodeURIComponent(sortingParameter)}`;
  }

  return '';
};

export const filtersToStandardQueryParams = (filters: string[]): string => {
  const filterParameter = filters ? filters.join(' and ') : null;

  if (filterParameter) {
    return `$filter=${encodeURIComponent(filterParameter)}`;
  }

  return '';
};
